export const AUTHENTICATE_USER = 'AUTHENTICATE_USER'
export const AUTHENTICATE_USER_RESPONSE = 'AUTHENTICATE_USER_RESPONSE'
export const AUTHENTICATE_USER_FAILED = 'AUTHENTICATE_USER_FAILED'